import * as SidebarConstants from 'sidebar/SidebarConstants';

const {Section} = SidebarConstants;

export const REQUEST_SCHEMA_SIDEBAR_SECTIONS = {
  ASSAY_REQUEST: Section.REQUEST_SCHEMAS,
  REQUEST_TASK: Section.REQUEST_TASK_SCHEMAS,
};
